import React from 'react';

import Skeleton from '@components/Skeleton/Skeleton';

import styles from './AncillaryServices.module.scss';

const PLACEHOLDER_COUNT = 5;

export const AncillaryServicesSkeleton: React.FC = () => {
  return (
    <div className={styles.ancillaryContainer}>
      <div className={styles.subContainer}>
        {Array.from({ length: PLACEHOLDER_COUNT }).map((_, idx) => (
          <div key={idx} className={styles.ancillaryService} aria-hidden>
            <Skeleton width={24} height={24} borderRadius={24} className={styles.ancillaryIcon} />
            <Skeleton width={80} height={14} borderRadius={8} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AncillaryServicesSkeleton;
